import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Import Luxembourg images
import luxembourg1 from '../images/luxembourg1.jpeg';
import luxembourg2 from '../images/luxembourg2.jpeg';
import luxembourg3 from '../images/luxembourg3.jpeg';
import luxembourg4 from '../images/luxembourg4.jpeg';
import luxembourg5 from '../images/luxembourg5.jpeg';
import luxembourg6 from '../images/luxembourg6.jpeg';
import luxembourg7 from '../images/luxembourg7.jpeg';
import luxembourg8 from '../images/luxembourg8.jpeg';
import luxembourg9 from '../images/luxembourg9.jpeg';
import luxembourg10 from '../images/luxembourg10.jpeg';
import luxembourg11 from '../images/luxembourg11.jpeg';
import luxembourg12 from '../images/luxembourg12.jpeg';
import luxembourg13 from '../images/luxembourg13.jpeg';
import luxembourg14 from '../images/luxembourg14.jpeg';
import luxembourg15 from '../images/luxembourg15.jpeg';
import luxembourg16 from '../images/luxembourg16.jpeg';
import luxembourg17 from '../images/luxembourg17.jpeg';
import luxembourg18 from '../images/luxembourg18.jpeg';
import luxembourg19 from '../images/luxembourg19.jpeg';
import luxembourg20 from '../images/luxembourg20.jpeg';
import luxembourg21 from '../images/luxembourg21.jpeg';
import luxembourg22 from '../images/luxembourg22.jpeg';
import luxembourg23 from '../images/luxembourg23.jpeg';
import luxembourg24 from '../images/luxembourg24.jpeg';
import luxembourg25 from '../images/luxembourg25.jpeg';
import luxembourg26 from '../images/luxembourg26.jpeg';
import luxembourg27 from '../images/luxembourg27.jpeg';
import luxembourg28 from '../images/luxembourg28.jpeg';
import luxembourg29 from '../images/luxembourg29.jpeg';
import luxembourg30 from '../images/luxembourg30.jpeg';
import luxembourg31 from '../images/luxembourg31.jpeg';

function Luxembourg() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    luxembourg1, luxembourg2, luxembourg3, luxembourg4, luxembourg5, luxembourg6,
    luxembourg7, luxembourg8, luxembourg9, luxembourg10, luxembourg11, luxembourg12,
    luxembourg13, luxembourg14, luxembourg15, luxembourg16, luxembourg17, luxembourg18,
    luxembourg19, luxembourg20, luxembourg21, luxembourg22, luxembourg23, luxembourg24,
    luxembourg25, luxembourg26, luxembourg27, luxembourg28, luxembourg29, luxembourg30,
    luxembourg31
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇱🇺 Luxembourg 2023 🇱🇺</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Luxembourg ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Luxembourg;